import PropTypes from "prop-types"
import { Tag } from "antd"
import {
  TAG_COLOR_MAP,
  LABEL_COLOR_OVERRIDE,
  isNeutralStyleLabel,
  isErrorNeutralStyleLabel,
  isRefundStyleLabel
} from "../BookingTable/ActionQueue/constants"
import styles from "./PaymentTag.module.css"

// Shared payment/collection status chip used by both the Action Queue and the
// Reservations listing so their tag colors and styling stay in sync.
// - "Operator To Collect" / "Link Sent" / "Auto-collect on {date}" → neutral white chip
// - "Auto-collection failed" → white surface with error color
// - everything else → status-colored Tag
const PaymentTag = ({ label, color }) => {
  if (isNeutralStyleLabel(label)) {
    return <Tag className={styles.operatorTag}>{label}</Tag>
  }
  if (isErrorNeutralStyleLabel(label)) {
    return <Tag className={styles.operatorTagError}>{label}</Tag>
  }
  if (isRefundStyleLabel(label)) {
    return <Tag className={styles.refundTag}>{label}</Tag>
  }
  return <Tag color={LABEL_COLOR_OVERRIDE[label] || TAG_COLOR_MAP[color] || "default"}>{label}</Tag>
}

PaymentTag.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string
}

export default PaymentTag
